/* 🤖 this file was generated by svg-to-ts */
export const iconExclamation: {
  name: 'exclamation';
  data: string;
} = {
  name: 'exclamation',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM8 0a2 2 0 0 1 2 2v7a2 2 0 1 1-4 0V2a2 2 0 0 1 2-2Z"/></svg>`,
};
